var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhereAndHowToInvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 19.75C18.0711 19.75 19.75 18.0711 19.75 16C19.75 13.9289 18.0711 12.25 16 12.25C13.9289 12.25 12.25 13.9289 12.25 16C12.25 18.0711 13.9289 19.75 16 19.75ZM16 21.5C19.0376 21.5 21.5 19.0376 21.5 16C21.5 12.9624 19.0376 10.5 16 10.5C12.9624 10.5 10.5 12.9624 10.5 16C10.5 19.0376 12.9624 21.5 16 21.5Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 2.5V3.53942C23.1061 4.02274 27.9773 8.89389 28.4606 15H29.5C30.0523 15 30.5 15.4477 30.5 16C30.5 16.5523 30.0523 17 29.5 17H28.4606C27.9773 23.1061 23.1061 27.9773 17 28.4606V29.5C17 30.0523 16.5523 30.5 16 30.5C15.4477 30.5 15 30.0523 15 29.5V28.4606C8.89389 27.9773 4.02274 23.1061 3.53942 17H2.5C1.94772 17 1.5 16.5523 1.5 16C1.5 15.4477 1.94772 15 2.5 15H3.53942C4.02274 8.89389 8.89389 4.02274 15 3.53942V2.5C15 1.94772 15.4477 1.5 16 1.5C16.5523 1.5 17 1.94772 17 2.5ZM16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16C27 22.0751 22.0751 27 16 27Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhereAndHowToInvest);
export default __webpack_public_path__ + "static/media/where-and-how-to-invest.6beeeb0f2cd593b92d9ac504e1574866.svg";
export { ForwardRef as ReactComponent };